import { render, staticRenderFns } from "./AlteracoesAssociacoesClube.vue?vue&type=template&id=6e5e026c"
import script from "./AlteracoesAssociacoesClube.vue?vue&type=script&lang=ts"
export * from "./AlteracoesAssociacoesClube.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports